// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SrYxK","type":"styles_type__fQriM","choices":"styles_choices__kRW69"};